export enum SOS_DEPARTMENTS {
    CM = 1,
    HA,
    MU,
    LOC,
    SET,
    PR
}
